<template>
  <header>
    <div class="wrap2 header-wrap">
      <div class="logo-wrapper">
        <router-link to="/index.html"><span class="logo"><img :src="logo" alt=""></span></router-link>
        <span class="subtitle" v-text="type"></span>
      </div>
      <div class="shop-user" v-if="userDisplayFlag">
        <el-dropdown @command="clickDropdownItem">
          <span class="el-dropdown-link">
            {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-for="(item, key) in dropdownList" :key="key" :command="key">
                {{ item }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
const DROPDOWN_LIST = {
  edit: '修改密码',
  quit: '退出登录'
}
export default {
  props: ['type', 'userDisplayFlag', 'userName', 'logo'],
  name: 'loginheader',
  data() {
    return {
      headerInfo: {
        userDisplayFlag: false
      },
      dropdownList: DROPDOWN_LIST,
      loading: true
    }
  },
  methods: {
    clickDropdownItem(command) {
      switch (command) {
        case 'edit': {
          this.$router.push('/updatePassword.html')
          break
        }
        case 'quit': {
          this.$confirm('是否确认退出？', '提示', { type: 'warning' }).then(async () => {
            QM.apinew({
              url: '/seller/user/logout',
              method: 'post',
              success: res => {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
              },
              error: () => {}
            })
            this.$emit('listenToChildEvent', this.headerInfo.userDisplayFlag, this.loading)
          })
          break
        }
      }
    }
  }
}
</script>

<style scoped>
  .header-wrap {
    position: relative;
    z-index: 999;
  }
  .logo-wrapper {
    display: inline-block;
    line-height: 76px;
    height: 76px;
  }
  .shop-user span{
    font-size: 14px;
    color: #333333;
  }
  .logo{
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
  }
</style>